import {
    OPEN_ORDER_DETAILS,
    CLOSE_ORDER_DETAILS,
    SEND_TO_SUPPLIER,
    UPDATE_SUGGESTED_ADDRESSES,
    CHANGE_SHOP_STATE,
} from "./orderDetails.actionsTypes";
import { FORCE_UPDATE_ORDER } from "../orders/order.actionsTypes";

export default function orderDetails(state = {}, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case OPEN_ORDER_DETAILS: {
            const { history, order, restaurants } = action;
            localStorage.setItem("v", order.__v);

            const mergedShops = order.shops.map((shop) => {
                const restaurant = restaurants.find((item) => item._id === shop.restaurantInfo._id);

                if (restaurant) {
                    const mergedBranches = shop.restaurantInfo.branches?.map((branch) => {
                        const secondBranch = restaurant.branches?.find((b) => b._id === branch._id);

                        if (secondBranch) {
                            return {
                                ...branch,
                                restaurantInformation: {
                                    ...branch.restaurantInformation,
                                    ...secondBranch.restaurantInformation,
                                },
                            };
                        }
                        return branch;
                    });

                    return {
                        ...shop,
                        isActive: restaurant.restaurantInformation.isActive || null,
                        restaurantInfo: {
                            ...shop.restaurantInfo,
                            mainBranch: {
                                isActive: restaurant.restaurantInformation.isActive,
                                isSupplier: restaurant.mainBranch.isSupplier,
                            },
                            restaurantInformation: {
                                ...shop.restaurantInfo.restaurantInformation,
                                isActive: restaurant.restaurantInformation.isActive || null,
                            },
                            branches: mergedBranches,
                        },
                    };
                }

                return shop;
            });

            return {
                // ...state,
                ...order,
                restaurants,
                shops: mergedShops,
                history,
                show: true,
                isNotEditable: action.isNotEditable,
                orderDetails: {
                    ...order,
                    restaurants,
                    shops: mergedShops,
                    history,
                    show: true,
                    isNotEditable: action.isNotEditable,
                },
            };
        }

        case CLOSE_ORDER_DETAILS:
            return {
                ...state, show: false,
                isNotEditable: false,
            };
        case FORCE_UPDATE_ORDER: {
            const updatedOrder = action.order;
            if (newState._id === updatedOrder._id) {
                return {
                    ...newState,
                    shops: updatedOrder.shops ? [...updatedOrder.shops] : newState.shops,
                };
            }
            return newState;
        }
        case SEND_TO_SUPPLIER: {
            const sendedOrder = action.order;
            localStorage.setItem("v", action.order.__v);
            if (newState._id === sendedOrder._id) {
                return {
                    ...newState,
                    __v: action.order.__v,
                    shops: newState.shops.map((shop, index) => ({
                        ...shop,
                        sendToPartner: sendedOrder.shops[index].sendToPartner,
                        sendToPartnerDate: sendedOrder.shops[index].sendToPartnerDate,
                        eta: sendedOrder.shops[index].eta,
                        state: sendedOrder.shops[index].state,
                    })),
                };
            }
            return { ...newState, __v: action.order.__v };
        }
        case CHANGE_SHOP_STATE: {
            const changedOrder = action.order;
            if (newState._id === changedOrder._id) {
                return {
                    ...newState,
                    shops: newState.shops.map((shop, index) => ({
                        ...shop,
                        state: changedOrder.shops[index].state,
                    })),
                };
            }
            return newState;
        }
        case UPDATE_SUGGESTED_ADDRESSES:
            newState.suggestedAddresses = action.addresses;
            return newState;
        default:
            return newState;
    }
}
